import { Realm } from "@xanadu/model";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class RealmCache extends DataCache<Realm> {
    constructor(
        dataService: DataService
    ) {
        super(Realm, dataService);
    }
}
